import { Button, ButtonSize, ButtonVariant, Icon, IconSize, IconVariants, Spinner, SpinnerSize } from "@next-platform/client-common-spicy-ui";

interface GenerateSuggestedFieldButtonProps {
  field: string;
  onButtonClick: () => Promise<void>;
  disabled?: boolean;
  isLoading?: boolean;
}

const GenerateSuggestedFieldButton = ({ field, onButtonClick, disabled = false, isLoading = false }: GenerateSuggestedFieldButtonProps) => {
  return (
    <Button
      onClick={onButtonClick}
      disabled={isLoading || disabled}
      data-testid={`generate-${field}-button`}
      size={ButtonSize.SMALL}
      variant={ButtonVariant.SECONDARY}
      type="button"
      className="flex items-center"
    >
      {isLoading ? (
        <Spinner size={SpinnerSize.SMALL} className="align-middle" />
      ) : (
        <Icon icon={IconVariants.SPARKLES} size={IconSize.SMALL} className="align-middle" />
      )}
    </Button>
  );
};

export default GenerateSuggestedFieldButton;
